import { Component, OnInit } from '@angular/core';
import { ExpressionOfInterestComponent } from './expression-of-interest/expression-of-interest.component';
import { ExpressionOfInterestViewComponent } from './expression-of-interest-view/expression-of-interest-view.component';
import { VIEW_MODE } from '@/app/interfaces/view-mode.enum';
import { CommonModule } from '@angular/common';
import { ProjectsService } from '@/app/services/projects/projects.service';

@Component({
  selector: 'app-project-expression-of-interest',
  standalone: true,
  imports: [
    ExpressionOfInterestComponent,
    ExpressionOfInterestViewComponent,
    CommonModule,
  ],
  templateUrl: './project-expression-of-interest.component.html',
  styleUrl: './project-expression-of-interest.component.css',
})
export class ProjectExpressionOfInterestComponent implements OnInit {
  constructor(private projectsService: ProjectsService) {}

  isEditMode = true; // Default to View mode
  VIEW_MODE = VIEW_MODE;
  mode: VIEW_MODE = VIEW_MODE.EDIT;
  expressionData: any;

  handleViewChange($event: any) {
    this.mode = $event;
  }

  // toggleMode(event: any): void {
  //   this.mode = event.checked ? VIEW_MODE.VIEW : VIEW_MODE.EDIT;
  //   console.log('Switched to', this.mode);
  // }

  toggleMode(): void {
    this.isEditMode = !this.isEditMode;
    if (this.isEditMode) {
      this.mode = VIEW_MODE.EDIT;
    } else {
      this.mode = VIEW_MODE.VIEW;
    }
    console.log('Switched to', this.isEditMode ? 'Edit Mode' : 'View Mode');
  }
  clickEditProjectBrief() {
    localStorage.setItem('isEdit', String(true));
  }

  ngOnInit(): void {
    // this.mode = VIEW_MODE.VIEW;
    this.getExpressionOfInterest();
  }
  getExpressionOfInterest() {
    this.projectsService.getProjectExpressions().subscribe({
      next: (data) => {
        this.expressionData = data.data;
        console.log('Expression of interest data fetched successfully:', data);
        if (this.expressionData.length > 0) {
          this.mode = VIEW_MODE.VIEW;
          this.isEditMode = false;
        } else if (this.expressionData.length === 0) {
          this.mode = VIEW_MODE.ADD;
          this.isEditMode = true;
        }
      },
      error: (error) => {
        console.error('Error fetching expression of interest data:', error);
      },
    });
  }
}
